import React from 'react'
import { FormContextProvider } from '../../../../context/formContext'
import { ElegibilidadProvider } from '../../../../context/ElegibilidadContext'
import Toast from '../../../../components/Toast/Toast'
import ViewSolicitudWorkshop from './ViewSolicitudWorkshop'

const FormNotificationsIFI = () => {
  return (
    <ElegibilidadProvider>
      <FormContextProvider>
        <Toast />
        <ViewSolicitudWorkshop />
      </FormContextProvider>
    </ElegibilidadProvider>
  )
}

export default FormNotificationsIFI
